export default __webpack_public_path__ + "static/service6-69d73b3f4ee1836bce6e2c2e2fb34b43.png";